var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "mb-4 pb-4" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "nav",
        { staticClass: "navbar navbar-light p-0 mb-4" },
        [
          _c("router-link", { attrs: { to: "/" } }, [
            _c("img", {
              staticClass: "logo-navbar p-2 bg-white mr-auto",
              attrs: { src: "content/images/ANFRlogo.png", alt: "ANFR" }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.pageTitle != ""
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-lg-2" },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "InscriptionFo" } } },
                  [
                    _c(
                      "p",
                      { staticClass: "btn btn-secondary" },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "mr-2",
                          attrs: { icon: "chevron-left" }
                        }),
                        _vm._v(
                          "\n                        Retour\n                    "
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-lg-10" }, [
              _c("h1", { attrs: { id: "page-title" } }, [
                _vm._v(_vm._s(_vm.pageTitle))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.displaySearchSessionsForm
        ? _c("div", { staticClass: "p-5 bg-white-opacity90" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-3 mt-2 mt-lg-0" }, [
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "scroll-to",
                        rawName: "v-scroll-to",
                        value: "#list-sessions",
                        expression: "'#list-sessions'"
                      }
                    ],
                    staticClass: "btn btn-primary btn-block",
                    on: { click: _vm.displayRegistrationForm }
                  },
                  [_vm._v("S'inscrire")]
                )
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-9" }, [
        _c("p", [
          _c("strong", [
            _vm._v("1) Je visualise les sessions du CRR Maritime et Fluvial")
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "font-italic" }, [
          _c("small", [
            _vm._v(
              "Mise à jour des sessions effectuée une fois chaque nuit, une session ouverte peut entretemps ne plus être disponible."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-3 mt-2 mt-lg-0" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-primary btn-block",
            attrs: { href: "https://crr.anfr.fr/index.php", target: "_blank" }
          },
          [_vm._v("Voir les sessions")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-lg-9" }, [
      _c("p", [
        _c("strong", [
          _vm._v(
            "2) Je transmets mon dossier en ligne et j'effectue le paiement"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }